import React from 'react';
import ModuleDetailPage from './ModuleDetailPage';

const AISystemPage = () => <ModuleDetailPage moduleId="ai-system" />;

export default AISystemPage;
